import React from 'react';
import { Card, CardContent } from '@material-ui/core';
import { Icon, Link, Typography } from '@knockrentals/knock-shared-web-v2';
import EditOverlay from './EditOverlay';
import { makeCss } from '../../../../knock-design-system';
import PropTypes from 'prop-types';

const useCss = makeCss(({ isDashedBorder }) => ({
  card: {
    ...(isDashedBorder && { borderStyle: 'dashed' }),
  },
  cardContent: {
    alignItems: 'center',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    textAlign: 'center',
  },
}));

const ActionTile = ({
  actionOnClick,
  actionText,
  children,
  className,
  iconName,
  subText,
}) => {
  const isDashedBorder = !children;
  const css = useCss({ isDashedBorder });

  return (
    <Card className={className} css={css.card} variant="outlined">
      {children ? (
        <EditOverlay actionOnClick={actionOnClick}>{children}</EditOverlay>
      ) : (
        <CardContent css={css.cardContent}>
          <Icon name={iconName} color="txt.secondary" aria-label={iconName} />

          <Link
            component="button"
            onClick={actionOnClick}
            variant="caption"
            underline="always"
          >
            {actionText}
          </Link>

          <Typography color="text.tertiary" variant="caption">
            {subText}
          </Typography>
        </CardContent>
      )}
    </Card>
  );
};

ActionTile.propTypes = {
  actionOnClick: PropTypes.func,
  actionText: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  iconName: PropTypes.string,
  subText: PropTypes.string,
};

export default ActionTile;
